import { Component, Inject, Optional, OnInit,Input,Output,EventEmitter} from '@angular/core';
import { Kri } from 'app/main/models/kri.model';
import { Medicion } from 'app/main/models/medicion.model';
import { KriService } from '../../../services/kri.service';
import {TranslateService} from '@ngx-translate/core';
import { DatePipe } from '@angular/common'
import {MatSnackBar} from '@angular/material/snack-bar';
import {FormControl} from '@angular/forms';


@Component({
  selector: 'mediciones-list',
  templateUrl: './mediciones-list.component.html',
  styleUrls: ['./mediciones-list.component.scss'],
  providers:[DatePipe]
})

export class MedicionesListComponent {

  @Input() kri: Kri;
  @Input() action: String;
  @Output() kriChange = new EventEmitter<Kri>();

  buttonAction :string  = "Agregar";
  hoy:Date = new Date();
  fecha:FormControl = new FormControl((new Date()).toISOString());
  tieneEditar:boolean = false;
  new_line_p:Medicion = {id:null,fecha:new Date(),valor:0,new:true};
  chartDataKris = [{series:[],name:""}];
  chartLabelsKris = [];
  chartDataKrisSingle = [];
  pieDataKris = [];
  view: any[] = [800, 500];
  // options
  legend: boolean = false;
  showLabels: boolean = true;
  animations: boolean = true;
  xAxis: boolean = true;
  yAxis: boolean = true;
  showYAxisLabel: boolean = true;
  showXAxisLabel: boolean = true;
  xAxisLabel: string = 'Fecha';
  yAxisLabel: string = 'Medición';
  timeline: boolean = true;
  serializedDate = null;

  colorScheme = {
    domain: ['#5AA454', '#E44D25', '#CFC0BB', '#7aa3e5', '#a8385d', '#aae3f5']
  };

  displayedColumns: string[] = ['fecha','valor','action'];

  constructor(
    public datepipe: DatePipe,
    public translate: TranslateService,
    private kriService: KriService,
    private _snackBar: MatSnackBar
    ) {

      this.kri = null;
    }


  ngOnInit(): void {

    this.chartDataKris[0].name=this.kri.nombre;
    this.tieneEditar = this.kri.tieneEditar;
    this.updateDataCharts();
  }

  addLine():void{


    if(this.kri.mediciones == undefined){
      this.kri.mediciones = [];
    }

    if('value' in this.fecha && this.fecha.value!=null){
      this.new_line_p.fecha = this.fecha.value;
    }

    if (this.new_line_p.new) {

      this.kriService.addMedicion(this.kri.id,this.new_line_p).pipe().subscribe(req => {
        //this.kri.mediciones.push(this.new_line_p);
        this.kri = {...req.body};

        this.updateDataCharts();
      },
      err => {
        this.openSnackBar("No se pudo agregar la medición, ocurrió un error.","Cerrar");

      });

    }else{
      this.kriService.alterMedicion(this.kri.id,this.new_line_p).pipe().subscribe(req => {
        //this.kri.mediciones.push(this.new_line_p);
        this.kri = {...req.body};
        this.updateDataCharts();
      },
      err => {
        this.openSnackBar("No se pudo modificar la medición, ocurrió un error.","Cerrar");

      });
    }

    //this.kri.mediciones.sort((a, b) => ((new Date(a.fecha)) > (new Date(b.fecha))) ? 1 : -1);

    //this.kri.mediciones = [...this.kri.mediciones];
    this.new_line_p = {id:null,fecha:new Date(),valor:0,new:true};
    this.buttonAction = "Agregar";

    //this.updateDataCharts();

  }

  updateDataCharts():void{
    this.pieDataKris = [];
    this.kri.mediciones.sort((a, b) => ((new Date(a.fecha)) > (new Date(b.fecha))) ? 1 : -1);
    this.kri.mediciones.forEach(element => {
      var fechaFormat = this.datepipe.transform(element.fecha, 'dd-MM-yyyy');
      this.chartDataKris[0].series.push({name:fechaFormat,value:element.valor});
      this.chartDataKrisSingle.push({name:fechaFormat,value:element.valor});
      this.pieDataKris.push({name:fechaFormat,value:element.valor});

    });

    this.kri.mediciones = [...this.kri.mediciones];
    this.chartDataKris = [...this.chartDataKris];
    this.pieDataKris = [...this.pieDataKris];
    this.chartDataKrisSingle = [...this.chartDataKrisSingle];

    this.kriChange.emit(this.kri);
  }

  edit(meicion: any):void{

    this.buttonAction = "Modificar";
    this.new_line_p = meicion;
    this.fecha = new FormControl((new Date(this.new_line_p.fecha)).toISOString());
    this.new_line_p.new = false;

  }

  remove(meicion: any): void {

    this.kriService.deleteMedicion(this.kri.id,meicion).pipe().subscribe(req => {
      //this.kri.mediciones.push(this.new_line_p);
      this.kri = {...req.body};
      //this.kri.mediciones = [...this.kri.mediciones];
      this.updateDataCharts();
    },
    err => {
      this.openSnackBar("No se pudo eliminar la medición, ocurrió un error.","Cerrar");

    });
    /*
    var index = -1;

    for(var i=0; this.kri.mediciones.length>i;i++){
      if((meicion.id!=null &&  this.kri.mediciones[i].id !=null &&
          this.kri.mediciones[i].id == meicion.id) ||
          (meicion.id==null &&  this.kri.mediciones[i].id ==null
            && meicion.fecha== this.kri.mediciones[i].fecha)
          ){
        index = i;
        break;
      }
    }

    if (index >= 0) {
      this.kri.mediciones.splice(index, 1);
    }
    this.kri.mediciones = [...this.kri.mediciones];
    */

  }

  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 3000,
    });
  }


}
